import { DateTime } from 'luxon';

const formatDateRange = (string: string) => {
  const dates = string.split('|');
  const startDate = DateTime.fromISO(dates[0]).toLocaleString();
  const endDate = DateTime.fromISO(dates[1]).toLocaleString();
  if (!startDate || !endDate) return '';
  return `${startDate} - ${endDate}`;
};

export { formatDateRange };
